import script from "./UserLayerController.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLayerController.vue?vue&type=script&setup=true&lang=js"

import "./UserLayerController.vue?vue&type=style&index=0&id=338a3bf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338a3bf0"]])

export default __exports__